import { createReducer, on } from '@ngrx/store';
import * as PricingActions from './pricing.actions';

export interface PricingState {
    developerPlanId: string | null;
    showPricingModal: boolean;
    subscription: {
        [key: string]: {
            endDate: string;
        };
    };
    currentUsage: {
        projectsCreated: number;
        virtualItemsCreated: number;
        nftMints: number;
    };
    developerPlans: {
        quotas: {
            [key: string]: {
                maxProjectsToCreate: number;
                maxVirtualItemsToCreate: number;
                maxNFTMints: number;
                maxNFTCopiesPerMint: number;
            };
        };
    };
    loading: boolean;
    error: string | null;
}

export const initialPricingState: PricingState = {
    developerPlanId: null,
    showPricingModal: false,
    subscription: {},
    currentUsage: {
        projectsCreated: 0,
        virtualItemsCreated: 0,
        nftMints: 0
    },
    developerPlans: {
        quotas: {}
    },
    loading: false,
    error: null
};

export const pricingReducer = createReducer(
    initialPricingState,
    on(PricingActions.loadPricingInfo, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(PricingActions.loadPricingInfoSuccess, (state, { pricingInfo }) => ({
        ...state,
        ...pricingInfo,
        loading: false
    })),
    on(PricingActions.loadPricingInfoFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(PricingActions.setPlan, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(PricingActions.setPlanSuccess, (state, { planId }) => ({
        ...state,
        developerPlanId: planId,
        loading: false
    })),
    on(PricingActions.setPlanFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(PricingActions.togglePricingModal, (state, { show }) => ({
        ...state,
        showPricingModal: show
    }))
); 